import { CONSTANT } from '../constant/constant.js';
import axios from 'axios';

import { errorHandler } from './error-helper';
import { successHandler, searchHandler } from './success-helper';

export const requestConfig = (params = null) => ({
    headers: {
        'Content-Type': 'application/json'
    },
    timeout: CONSTANT.timeout,
    params: params
});

export const generalHttpGetRequest = (url, params, useSearchHandler) =>
    axios
        .get(url, requestConfig(params))
        .then(response => {
            if (useSearchHandler) {
                searchHandler(response);
            }
            return new Promise((resolve, reject) => resolve(response));
        })
        .catch(error => {
            errorHandler(error);
            return new Promise((resolve, reject) => reject(error));
        });

export const generalHttpPostRequest = (url, payload, params) =>
    axios
        .post(url, payload, requestConfig(params))
        .then(response => {
            successHandler(response);
            return new Promise((resolve, reject) => resolve(response));
        })
        .catch(error => {
            errorHandler(error);
            return new Promise((resolve, reject) => reject(error));
        });

export const generalHttpPutRequest = (url, payload) =>
    axios
        .put(url, payload, requestConfig())
        .then(response => {
            successHandler(response);
            return new Promise((resolve, reject) => resolve(response));
        })
        .catch(error => {
            errorHandler(error);
            return new Promise((resolve, reject) => reject(error));
        });



// WEBPACK FOOTER //
// ./src/services/helper/request-helper.js